<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-'+item.ID">
                <td>{{ item.PackageCode }}</td>
                <td class="text-right">{{ item.Weight }}</td>
                <td class="text-right">{{ item.Volume }}</td>
                <td class="text-right">{{ item.Amount | currency }}</td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td>{{ item.CreatedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)"> {{ (packageRole & 8) ? 'edit' : 'visibility'}}</v-icon>
                  <v-icon v-if="(packageRole & 4)" medium @click="deleteItem(item.ID)">delete</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>      
       <big-package-popup
        :readOnly="!(packageRole & 8)"
        :dialogPackageDetail="dialogPackageDetail"
        v-on:closePopup="closePopup"
        @deleteItem="deleteItem"
      ></big-package-popup>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import big_package from "@/components/popups/big_package";
import Filtering from "@/components/Filtering";
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
    "big-package-popup": big_package,
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "Bao hàng",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Số gói",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí ship",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ngày tạo",
          value: "CreatedDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Người tạo",
          value: "CreatedBy",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "bigpackage_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      dialogPackageDetail: false
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true
    },
    packageRole() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.packageRole & 2)});
    }
  },
  computed: {
    ...mapState({
      items: state => state.bigPackage.all.data,
      total_rows: state => state.bigPackage.all.total,
      currentItem: state => state.bigPackage.selected,
      loading: state => state.bigPackage.loading
    }),
    packageRole() {
      return this.$store.state.authentication.role.BigPackage;
    }
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("bigPackage/getList", param);
    },
    gotoDetail: function(id) {
      let configPaging = _.cloneDeep(configs.PAGINATION);
      configPaging.itemsPerPage = 5;
      var param = {
         pagination: {
            ...configPaging,
            itemsPerPage: 1000000
          }
      };
      
      this.$store.dispatch("bigPackage/getDetail", {'id': id, 'param': param});
      setTimeout(() => {this.dialogPackageDetail = true}, 200);
    },
    deleteItem: function(id) {
      if(this.packageRole & 4) {
        window.getApp.$emit("REQUEST_DELETE_DATA", id);
      }
      else {
        sendErrorNotice('Bạn không có quyền xóa bao hàng.')
      }
    },    
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      if(this.packageRole & 2) {
        this.$store.commit("bigPackage/setDetail", {
          data: {
            ID: 0,
            PackageCode: '',
            ReceivePlaceID: 1,
            Weight: 0,
            Volume: 0,
            Amount: 0,
            Status: 0,
            Packages: []
          }
        });
        this.dialogPackageDetail = true;
      }
      else {
        sendErrorNotice('Bạn không có quyền thêm mới bao hàng.')
      }
    },
    saveItem(item) {
      this.$store.dispatch("bigPackage/setDetail", {
        data: item,
        id: item.ID
      });
    },
    saveData() {
      this.saveItem(this.currentItem);
      this.dialogPackageDetail = false;
    },
    closePopup() {
      this.dialogPackageDetail = false;
      this.filter_data();
    }
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !(this.packageRole & 2)});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
      this.$store.dispatch("bigPackage/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
